"use client";
import { useFormatter, useTranslations } from "next-intl";
import clsx from "clsx";
import Image from "next/image";
import { useEffect, useRef, useState } from "react";
import fireIcon from "@public/fire_icon.png";

import s from "./styles.module.css";

const burned = {
  2022: 1.2,
  2023: 1.28,
  2024: 1.04,
  2025: 131,
};

const TOTAL_BURNED = 3.359;

export default function BurnHistory() {
  const t = useTranslations("BurnHistory");
  const f = useFormatter();
  const containerRef = useRef(null);

  const [isReached, setIsReached] = useState(false);

  useEffect(() => {
    const container = containerRef.current;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsReached(true);
            observer.unobserve(entry.target);
          }
        });
      },
      {
        rootMargin: "90px", // offset
        threshold: 1.0,
      }
    );

    if (container) {
      observer.observe(container);
    }

    return () => {
      if (container) {
        observer.unobserve(container);
      }
    };
  }, []);
  return (
    <div className={s.container} ref={containerRef}>
      <div className={s.radixContainer}>
        <div className={s.points}>
          <div className={clsx(s.first, isReached && s.showFirst)}>
            <span className={s.amount}>
              {t("billionBurned", { amount: f.number(burned["2022"]) })}
              <span className={s.date}>2022</span>
            </span>
            <div className={s.checkpoint} />
          </div>
          <div className={clsx(s.second, isReached && s.showSecond)}>
            <span className={s.amount}>
              {t("billionBurned", { amount: f.number(burned["2023"]) })}
              <span className={s.date}>2023</span>
            </span>
            <div className={s.checkpoint} />
          </div>
          <div className={clsx(s.third, isReached && s.showThird)}>
            <span className={s.amount}>
              {t("billionBurned", { amount: f.number(burned["2024"]) })}
              <span className={s.date}>2024</span>
            </span>
            <div className={s.checkpoint} />
          </div>
          <div className={clsx(s.fourth, isReached && s.showFourth)}>
            <span className={s.amount}>
              {f.number(burned["2025"])} million
              <span className={s.date}>{t("currentYear", { year: 2025 })}</span>
            </span>
            <div className={s.checkpoint} />
          </div>
        </div>
      </div>
      <div className={clsx(s.radix, isReached && s.radixVisible)}>
        <div className={s.burnIconContainer}>
          <Image alt="Burn icon" className={s.burnIcon} src={fireIcon} />
        </div>
      </div>
      <h3
        className={clsx(
          s.totalBurnedTitle,
          isReached && s.totalBurnedTitleShow
        )}
      >
        {t("billionBurned", { amount: f.number(TOTAL_BURNED) })}
      </h3>
      <p
        className={clsx(
          s.totalBurnedSubtitle,
          isReached && s.totalBurnedSubtitleShow
        )}
      >
        {t("totalBurnedSubtitle")}
      </p>
    </div>
  );
}
